import { joinString } from "@Common/helpers/Modifiers/characters";

const getPayPlanPosition = (position: string, addition = "") => joinString(position, addition, true);

export { getPayPlanPosition };
